import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const firstName: AnswerPathTreeNode = { path: 'firstName', nodeId: NodeIds.insuredFirstName };
